import cn from 'classnames'
import Link from 'next/link'
import React from 'react'
import {
  IEnum_Solution_Item_Type,
  ISolutionListItemFragment,
  ISubTopicItemFragment,
  ITopicItemFragment,
} from 'src/graphql/generated/hooks'

import { VendorListItem } from './VendorListItem/VendorListItem'

export interface VendorlistProps {
  items: ISolutionListItemFragment[]
  topic?: ITopicItemFragment
  subTopic?: ISubTopicItemFragment
  className?: string
  companyName?: string
  isManage?: boolean
}

export const VendorList: React.FC<VendorlistProps> = ({
  items,
  className = '',
  topic,
  subTopic,
  companyName,
  isManage,
}) => {
  return (
    <div className={cn(className, 'bg-white', 'border-y', 'border-zinc-300')}>
      <ul className="divide-y divide-zinc-300">
        {items.map((item, index) => {
          let href = ''
          if (item.type === IEnum_Solution_Item_Type.Alsp) {
            href = '/alsps/' + item.slug
          } else if (item.type === IEnum_Solution_Item_Type.Consultancy) {
            href = '/consultants/' + item.slug
          } else if (item.type === IEnum_Solution_Item_Type.Product) {
            href = '/vendors/' + item.slug
          } else if (item.type === IEnum_Solution_Item_Type.Company) {
            href = '/companies/' + item.slug
          }

          return (
            <li key={index} className="flex flex-row justify-center items-center">
              <div className="flex-1">
                <VendorListItem
                  item={item}
                  href={href}
                  topic={topic}
                  subTopic={subTopic}
                  companyName={companyName}
                  showCompare={!isManage}
                  showFollow={!isManage}
                />
              </div>
              {isManage && (
                <div>
                  <Link href={href + '?viewType=manage'}>
                    <button className="box-border h-[50px] w-[130px] border-solid border-[1px] border-mist rounded-full bg-navy text-white items-center justify-center font-semibold">
                      View / Edit
                    </button>
                  </Link>
                  <Link href={`/add-annoucements/${item.slug}/`}>
                    <button className="box-border h-[50px] w-[200px] border-solid border-[1px] border-mist rounded-full bg-navy text-white items-center justify-center font-semibold">
                      Add Announcement
                    </button>
                  </Link>
                </div>
              )}
            </li>
          )
        })}
      </ul>
    </div>
  )
}
